import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-maintenance-modal',
  templateUrl: './maintenance-modal.component.html',
  styleUrls: ['./maintenance-modal.component.scss'],
})
export class MaintenanceModalComponent {

  constructor(
    private _modalCtrl: ModalController
  ) { }

  close() {
    this._modalCtrl.dismiss();
  }
}
